// eslint-disable-next-line import/prefer-default-export
export function page(state) {
  return state.page;
}



// WEBPACK FOOTER //
// ./src/app/edit-page/store/getters.js